import { Icon, IconType } from '../../../theme/icon';

type Props = {
  icon: IconType;
};

export const InputIcon = ({ icon }: Props) => {
  return <Icon icon={icon} />;
};
